import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import store from './store/adminStore';
import 'bootstrap/dist/css/bootstrap.min.css';
import { AuthContextProvider } from 'hooks/useAuth';
import ErrorBoundary from 'components/ErrorBoundary';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { NotificationProvider } from 'pages/Notification/context';

if (
  process.env.NODE_ENV === 'development' ||
  process.env.NODE_ENV === 'production'
) {
  window.addEventListener(
    'error',
    (e) => {
      if (
        e.message ===
        'ResizeObserver loop completed with undelivered notifications.'
      ) {
        e.stopImmediatePropagation();
      }
    },
    true
  );

  window.addEventListener(
    'unhandledrejection',
    (event) => {
      if (
        event.reason?.message ===
        'ResizeObserver loop completed with undelivered notifications.'
      ) {
        event.preventDefault();
      }
    },
    true
  );
}
if ('serviceWorker' in navigator) {
  navigator.serviceWorker
    .register('/firebase-messaging-sw.js')
    .then((registration) => {
      console.log('✅ SW registered: ', registration.scope);
    })
    .catch((err) => {
      console.error('❌ SW registration failed: ', err);
    });
}

// ✅ ResizeObserver Error Suppression (MUST be in capture phase)
if (process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'production') {
  window.addEventListener(
    'error',
    (e) => {
      if (
        e.message ===
        'ResizeObserver loop completed with undelivered notifications.'
      ) {
        e.stopImmediatePropagation();
      }
    },
    true // <- capture phase, very important!
  );

  window.addEventListener(
    'unhandledrejection',
    (event) => {
      if (
        event.reason?.message ===
        'ResizeObserver loop completed with undelivered notifications.'
      ) {
        event.preventDefault();
      }
    },
    true
  );
}

const root = ReactDOM.createRoot(document.getElementById('root')!);
root.render(
  <Provider store={store}>
    <ErrorBoundary>
      <AuthContextProvider>
        <BrowserRouter>
          <NotificationProvider>
            <App />
            <ToastContainer />
          </NotificationProvider>
        </BrowserRouter>
      </AuthContextProvider>
    </ErrorBoundary>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
